module.exports = __webpack_public_path__ + "static/img/trees.eca31cd7.gif";